import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";

import {
  salesOrderAutoShipNoticeRequestTable,
  salesOrderBgSummaryRecordsTable,
  salesOrderFAMDepreciationHistoryTable,
  salesOrderFamAssetTable,
  salesOrderFamExpenseIncomeTable,
  salesOrderHoldHistoryTable,
  salesOrderRelationshipsTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Stack,
  Button,
  CircularProgress,
} from "@mui/material";
import {
  BgSummaryrecordTable,
  BgIncomeTable,
  BgDeprecitionHistoryTable,
  BgFAMAssetTable,
} from "../../../config/grid-column-defs";

import TabPanel from "../../../components/TabPanel";
import {
  getTransactionAutoShipNoticeRequest,
  getTransactionCustomAutoInvoiceRequest,
  getTransactionCustomSalesOrderHoldHistory,
  getTransactionRelationshipcontact,
  getTransactionSalesOrderHoldHistory,
} from "../../../api/journal";
import { GridComp4 } from "../../../components/GridComponents";
import { CustomCheckBox } from "../../../components/CheckboxComp";
import { getTransactionCustom } from "../../../api/transaction-type";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));

 
export default function DepositCustom({tabIndexP}) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }
 useEffect(() => {
    if (user.token) {
      getTransactionCustomData();
    }
  }, []);

  async function getTransactionCustomData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustom(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data[0]);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
    setRowData([]);
  }

  const buttonStyle = {
    margin: "5px", // Adjust the spacing as needed
  };
  return (
    <>
      <Box
        className="viewBox sub-tab"
        sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
      >
        {/* {rowData?.map((el, index) => ( */}
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <GridComp4
                title={" GP TRANSACTION ID"}
                data={rowData?.gp_transaction_id}
              />
              <GridComp4
                title={"CREATED BY"}
                data={rowData?.next_approver}
              />
              <CustomCheckBox
                title={"INTERCOMPANY CC TRANSACTION"}
                data={rowData?.project_sigma_transaction}
              />
              <CustomCheckBox title={"AUTO APPROVED MESSAGE"} data={rowData?.asc_606_2019} />
              <CustomCheckBox title={"ITEM RECEIPT REVERSAL"} data={rowData?.asc_606_2020} />
              <CustomCheckBox
                title={"HISTORICAL DATA MIGRATION"}
                data={rowData?.exclude_from_deferred}
              />
              <CustomCheckBox title={"RUN SCHEDULED SCRIPT"} data={rowData?.helix} />
            
            </Grid>
            <Tabs
              value={tabIndexRelatedRecord}
              // onChange={handleChange}
              onChange={(e, nv) => {
                setTabIndexRelatedRecord(nv);
              }}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              className={`${classes.spacedTabs} tabs-sub-bkg`}
              // className="tabs-sub-bkg"
            >
              <Tab label="BG Summary Records" />
              <Tab label="FAM Expense/Income" />
              <Tab label="FAM Depreciation History" />
              <Tab label="FAM Asset" />
            </Tabs>
            <TabPanel value={tabIndexRelatedRecord} index={0}>
              <Grid container spacing={1} style={{ margin: "1px" }}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      BG Summary Records
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Box
                sx={{
                  p: 1,
                }}
              >
                <Stack spacing={2} direction="row">
                  <Button className="blue-button">
                    New BG Summary Records
                  </Button>
                  <Button className="blue-button">Attach</Button>
                  <Button className="blue-button">Customize View</Button>
                </Stack>
              </Box>
              <AgGridPaginatedTable
                getTableRows={undefined}
                columns={BgSummaryrecordTable}
                refreshCounter={0}
                perPage={5}
              />
            </TabPanel>
            <TabPanel value={tabIndexRelatedRecord} index={1}>
              <Grid container spacing={1} style={{ margin: "1px" }}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      FAM Expense/Income
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Box
                sx={{
                  p: 1,
                }}
              >
                <Stack spacing={2} direction="row">
                  <Button className="blue-button">
                    New FAM Expense/Income
                  </Button>
                  <Button className="blue-button">Attach</Button>
                  <Button className="blue-button">Customize View</Button>
                </Stack>
              </Box>
              <AgGridPaginatedTable
                getTableRows={undefined}
                columns={BgIncomeTable}
                refreshCounter={0}
                perPage={5}
              />
            </TabPanel>
            <TabPanel value={tabIndexRelatedRecord} index={2}>
              <Grid container spacing={1} style={{ margin: "1px" }}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      FAM Depreciation History
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Box
                sx={{
                  p: 1,
                }}
              >
                <Stack spacing={2} direction="row">
                  <Button className="blue-button">
                    New FAM Depreciation History
                  </Button>
                  <Button className="blue-button">Attach</Button>
                  <Button className="blue-button">Customize View</Button>
                </Stack>
              </Box>
              <AgGridPaginatedTable
                getTableRows={undefined}
                columns={BgDeprecitionHistoryTable}
                refreshCounter={0}
              />
            </TabPanel>
            <TabPanel value={tabIndexRelatedRecord} index={3}>
              <Grid container spacing={1} style={{ margin: "1px" }}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      FAM Asset
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Box
                sx={{
                  p: 1,
                }}
              >
                <Stack spacing={2} direction="row">
                  <Button className="blue-button">New FAM Asset</Button>
                  <Button className="blue-button">Attach</Button>
                  <Button className="blue-button">Customize View</Button>
                </Stack>
              </Box>
              <AgGridPaginatedTable
                getTableRows={undefined}
                columns={BgFAMAssetTable}
                refreshCounter={0}
              />
            </TabPanel>
          </Box>
        {/* ))} */}
      </Box>
    </>
  );
}
